import styled from 'styled-components'
import {LinkEl} from '../NonHomeVideoItem/styledComponents'

export const GameLinkEl = styled(LinkEl)`
  text-decoration: none;
  width: 22%;
`

export const GameVidItem = styled.li`
  margin: 20px;
`

export const GameThumbnailImg = styled.img`
  width: 100%;
  margin-bottom: 5px;
  height: 320px;
`
